import { userFeature } from "./user.reducer";

export const selectCurrentUser = userFeature.selectCurrentUser;
